import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_PPMU_SUNRISE_DOUBLE_HOLDOUT_EXPERIMENT = createFcmDetails(
	'revenue_ppmu_sunrise_double_holdout_experiment',
	{
		owner: 'Revenue Squad',
		context: 'Post Promote Membership Upsell (PPMU)',
		import: false,
		description:
			'Experiment to track churn over time through two PPMU holdout groups: https://change.atlassian.net/browse/CHANGE-76340',
		template: {
			experimentName: '',
		},
	},
);
